export default "__VITE_ASSET__DbJ8i_KT__"